import { render, staticRenderFns } from "./PaymentShipmentV2.vue?vue&type=template&id=21283647"
import script from "./PaymentShipmentV2.vue?vue&type=script&lang=js"
export * from "./PaymentShipmentV2.vue?vue&type=script&lang=js"
import style0 from "./PaymentShipmentV2.vue?vue&type=style&index=0&id=21283647&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports